// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { DealerIndustriesModel, getDealersIndustries } from "@keller/App/Services/DealerService";

type HandlerType = ApiHandler<
    HasOnSuccess<DealerIndustriesModel> & HasOnError<string>,
    DealerIndustriesModel & { error?: string }
>;

export const DispatchBeginLoadCreateAccountInfo: HandlerType = props => {
    props.dispatch({
        type: "xDealers/BeginLoadDealersIndustries" as any,
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getDealersIndustries();
    } catch (error) {
        props.apiResult.error =
            error.errorMessage || "Please try again and contact support if you continue to have issues.";
    }
};

export const DispatchCompleteLoadDealersIndustries: HandlerType = props => {
    props.dispatch({
        type: "xDealers/CompleteLoadDealersIndustries",
        collection: props.apiResult.industries || [],
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    const { error, industries } = props.apiResult;
    if (!error) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.({ industries });
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult.error) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const chain = [
    DispatchBeginLoadCreateAccountInfo,
    RequestDataFromApi,
    DispatchCompleteLoadDealersIndustries,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const loadDealersIndustries = createHandlerChainRunner(chain, "LoadDealersIndustries");

export default loadDealersIndustries;
